export const errorMsg = {
  FE001: 'K uvedenej poistnej zmluve aktuálne neočakávame fotografie z obhliadky vozidla. Termíny pre vykonanie obhliadky nájdete v poistnej zmluve.',
  FE002: 'Zadané číslo poistnej zmluvy je v nesprávnom formáte.',
  FE003: 'Údaje poistníka nesúhlasia s údajmi poistníka na zadanej poistnej zmluve.',
  FE004: 'Dátum narodenia je v nesprávnom formáte.',
  FE005: 'Údaje poistníka nesúhlasia s údajmi poistníka na zadanej poistnej zmluve.',
  FE006: 'Zadané IČO je v nesprávnom formáte.',
  FE007: 'Zadajte emailovú adresu v správnom formáte.',
  FE008: 'Prosím, zadajte emailovú adresu, na ktorú Vám pošleme potvrdenie o úspešnom uložení fotografií v našom systéme.',
  FE013: 'Prekročený povolený limit fotografií.',
  FE014: 'Pre dokončenie odstráňte všetky chybné súbory.',
  FE015: 'Pre dokončenie je potrebné nahrať všetky požadované fotografie.',
  FE020: 'Pre využitie funkcie uložiť na neskôr je potrebné vyplniť e-mailovú adresu aj súhlas.',
  FE021: 'Pre využitie funkcie uložiť na neskôr je potrebné vyplniť e-mailovú adresu aj súhlas.',
  FE022: 'Zadajte počet najazdených kilometrov(1 - 9 999 999 km).',
};
export const photoDesc = {
  FRONT: 'Čelná strana vozidla vrátane EČV',
  WINDSHIELD: 'Čelné sklo',
  BACK: 'Zadná strana',
  LEFT: 'Ľavý bok - kolmý záber',
  RIGHT: 'Pravý bok - kolmý záber',
  VIN: 'VIN číslo',
  CLOCK: 'Odometer',
  DASHBOARD: 'Palubná doska',
  DAMAGES: 'Poškodenia',
  ADDITIONALEQUIPMENT: 'Doplnková výbava',
  SECURITY: 'Zabezpečovacie zariadenie',
};
